import { JSONContent } from '@tiptap/core';

import { useRichtext } from 'approot/shared/richtext/richtext.hooks';
import { useInputFieldState } from '../../component.hooks';
import RichtextInline from 'approot/shared/richtext/richtext-inline';
import { INTERACTIVE_RICHTEXT_SETTINGS } from '../interactive-response-shared.constants';

type Props = {
  data: JSONContent | null;
  onChange: (json: JSONContent) => void;
};

const InteractiveResponseRichtextEdit = ({ onChange, data }: Props) => {
  const { setEditorStateToUpdate } = useInputFieldState<JSONContent>({
    onChange: json => onChange(json),
  });

  const { editor } = useRichtext({
    onChange: json => setEditorStateToUpdate(json),
    settings: INTERACTIVE_RICHTEXT_SETTINGS,
    initialValue: data || undefined,
  });

  return (
    <>
      {editor && (
        <RichtextInline
          editor={editor}
          characterLimit={INTERACTIVE_RICHTEXT_SETTINGS.maxCharacterCount}
        />
      )}
    </>
  );
};

export default InteractiveResponseRichtextEdit;
